module.exports = __webpack_public_path__ + "static/media/thumbnail.33507538.jpg";